import { useQuery } from "@tanstack/react-query";
import { fetchProducts } from "../services/productService";

export const useProducts = (
  page = 1,
  search = "",
  category_id = "",
  status = "",
  stock_level = "",
  gender = "",
  best_seller = "",
  min_price = "",
  max_price = "",
) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [
      "products",
      page,
      search,
      category_id,
      status,
      stock_level,
      gender,
      best_seller,
      min_price,
      max_price,
    ],
    queryFn: () =>
      fetchProducts(
        page,
        search || "",
        category_id,
        status,
        stock_level,
        gender,
        best_seller,
        min_price,
        max_price,
      ),
    select: (response) => ({
      products: response.message?.products?.data || [],
      pagination: {
        current_page: response.message?.products?.current_page,
        total: response.message?.products?.total,
        per_page: response.message?.products?.per_page,
        last_page: response.message?.products?.last_page,
      },
    }),
  });

  return {
    products: data?.products || [],
    loading: isLoading,
    error: error?.message || null,
    pagination: data?.pagination || null,
  };
};
